import { render } from "./AdicionarTexto.vue?vue&type=template&id=513af165&ts=true"
import script from "./AdicionarTexto.vue?vue&type=script&lang=ts"
export * from "./AdicionarTexto.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__